import { type ReactNode } from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useTranslation } from "react-i18next";
import LoginPage from "@/pages/LoginPage";

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { inProgress } = useMsal();
  const { t } = useTranslation();

  // Al volver del redirect de Microsoft, MSAL canjea el `code` en segundo plano
  // y msal-react ya da por autenticado al usuario (la cuenta esta cacheada):
  // AuthenticatedTemplate solo espera al arranque, no al canje. Si la app se
  // monta en ese momento, cada consumidor pide token con el refresh token
  // viejo, que falla justo en el caso que provoco el redirect, y el fallback
  // vuelve a navegar a Microsoft a mitad del canje. Hasta que el canje termina
  // no hay nada que mostrar.
  if (inProgress === InteractionStatus.HandleRedirect) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-[var(--muted-foreground)]">{t("auth.loading")}</p>
      </div>
    );
  }

  return (
    <>
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        {children}
      </AuthenticatedTemplate>
    </>
  );
}
